import { useState } from 'react';
import {
    Container,
    SelectCountry
} from './styled';
import {
    Search
} from '../../components';
import {
    BiChevronDown,
    BiChevronUp,
} from 'react-icons/bi';
import countries from '../../constants/countries.json';

export const InputPhone = (props) => {

    const {
        id,
        value,
        onChange,
        name,
        disable,
        className
    } = props

    const [selectCountry, setSelectCountry] = useState(false);
    const [countrySelected, setCountrySelected] = useState(
        {
            "name": "Brasil",
            "idd": "+55",
            "flag": "https://flagcdn.com/br.svg"
        }
    );

    const maskPhone = (idd, value) => {
        if (idd !== '+55') return value.replace(/\D/g, "")
        return value
            .replace(/\D/g, "")
            .replace(/(\d{2})(\d)/, "($1) $2")
            .replace(/(\d{5})(\d)/, "$1-$2")
            .replace(/(-\d{4})(\d+?)$/, "$1");
    };
    const RenderCountries = () => {
        const [filter, setFilter] = useState('');
        function onFilter(country) {
            return country?.name?.toLowerCase()?.includes(filter?.toLowerCase());
        };
        return (
            <SelectCountry isOpen={selectCountry} >
                <div>
                    <Search
                        className="search-country"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
                <ul>
                    {countries?.filter(onFilter)?.map((country) =>
                        <li
                            key={`${country?.name}-${country?.idd}`}
                            onClick={() => {
                                setSelectCountry(false)
                                setCountrySelected(country)
                                onChange(
                                    country?.idd,
                                    maskPhone(country?.idd, value)
                                )
                            }}
                        >
                            <img
                                src={country?.flag}
                                alt={`flag-${country?.name}`}
                            />
                            <span>
                                {`${country?.name} 
                                (${country?.idd})`}
                            </span>
                        </li>
                    )}
                </ul>
            </SelectCountry>
        )
    };

    return (
        <Container disable={disable} className={className}>
            <div
                onClick={() => {
                    setSelectCountry(!selectCountry)
                }}
            >
                <img
                    src={countrySelected?.flag}
                    alt="flag"
                />
                {!selectCountry
                    ? (<BiChevronDown fontSize={`1.5rem`} />)
                    : (<BiChevronUp fontSize={`1.5rem`} />)
                }
            </div>
            <div>
                <input
                    id={id}
                    name={name}
                    value={value}
                    onChange={(e) => {
                        onChange(
                            countrySelected?.idd,
                            maskPhone(
                                countrySelected?.idd,
                                e.target.value
                            )
                        )
                    }}
                    placeholder={
                        `${countrySelected?.name === 'Brasil'
                            ? ('(00) 00000-0000')
                            : ('')
                        }`
                    }
                />
            </div>
            <RenderCountries />
        </Container>
    );

};
